import React, { Fragment } from "react";
import { Link } from 'react-router-dom';


const Description = ()=> {

  return (
    <Fragment>
      <div className="description-overlay">
        <h5> Complete a Daily Check-in </h5>
        <p> The easiest way to start is to redeem your first Daily Bonus and get an instant reward of <strong>10</strong> points. </p>
      </div>
      <Link className="btn action btn-primary" to={"/check-in"}>Claim Bonus</Link>
    </Fragment>
  );
};

export default Description;
